import { render, staticRenderFns } from "./CityName.vue?vue&type=template&id=4ea060d5&scoped=true&"
import script from "./CityName.vue?vue&type=script&lang=js&"
export * from "./CityName.vue?vue&type=script&lang=js&"
import style0 from "./CityName.vue?vue&type=style&index=0&id=4ea060d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea060d5",
  null
  
)

export default component.exports